module.exports = __webpack_public_path__ + "img/logo.463a8977.png";